module.exports = __webpack_public_path__ + "static/media/line_chart_empty.351fc60b.svg";